import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalBody, ModalHeader } from 'reactstrap';
import { IModalProps } from '../../../types';
import { UpdateForm } from '../../ProductReleases/UpdateForm';

export const UpdateProductRelease: FunctionComponent<IModalProps> = (props) => {
  const { t } = useTranslation();

  const { hideModal, data } = props;

  return (
    <>
      <ModalHeader className="font-montserrat m-0 border-0">
        {t('updateProductRelease.header', { name: data.version })}
      </ModalHeader>
      <ModalBody>
        <UpdateForm productRelease={data} onCancel={hideModal} />
      </ModalBody>
    </>
  );
};
